export const getPlatformConfig = (
  platform,
  mode = "production",
  modeBuild = "dev"
) => {
  let env;

  if (ENV_JSON) {
    env = ENV_JSON;
  }else if (ENV_MODE == 'production' && require(`@/configuration/platforms/${platform}/env.${modeBuild}.json`)) {
    env = require(`@/configuration/platforms/${platform}/env.${modeBuild}.json`);
  }else{
    env = require('@/configuration/env.json');
  }

  let theme = require(`@/configuration/theme/${env.THEME_NAME}.json`);
  let custom = [];

  // CUSTOM THEME
  try {
    let customTheme;
    if (EXISTS_THEME_CLIENT_JSON) {
      customTheme = require(`@/configuration/client/theme/custom.json`)
    }else{
      customTheme = require(`@/configuration/platforms/${env.PLATFORM}/theme/custom.json`);
    }

    if (customTheme) {
      theme = mergeDeep(theme, customTheme);
    }
  } catch (ex) {}

  // CUSTOM PLATFORM
  try {

    if (CLIENT_DIR){
      custom = require(`@/configuration/client/custom.json`);
    }else{
      custom = require(`@/configuration/platforms/${env.PLATFORM}/custom.json`);
    }

    if (custom?.global?.header) {
      let header = custom?.global?.header || {};
      env.HEADER = mergeDeep(env.HEADER, header);
    }
  } catch (ex) {
    if (env.DEBUG) {
      console.error(`Could not load custom file: ${env.PLATFORM}`);
    }
  }

  // [TODO]
  // Temos de resolver primeiro a situação do problema
  // Cannot use import statement outside a module
  // para importar a função do config/utils

  return {
    THEME: theme,
    CUSTOM: custom,
    ...env,
  };
};

const func = {
  getPlatformConfig,
};

export default func;
